<div class="vendor-profile-page">
  <div class="navigation-breadcrumb">
    <span class="breadcrumb-text" (click)="navigateToVendorDashboard()">
      {{ getBreadcrumbLabel() }}
    </span>
    <span class="breadcrumb-separator"> / </span>
    <span class="breadcrumb-text" (click)="navigateToVendorsList()">
      {{ getSeparatorBreadcrumbLabel() }}
    </span>
    <span class="breadcrumb-separator"> / </span>
    <span class="breadcrumb-text">
      {{ BreadcrumbLabels.VendorProfile }}
    </span>
  </div>
  <div class="vendor-profile-container">
    <div class="header-row">
      <h1 class="title">{{ vendorName }}</h1>
      <emerald-button
        [label]="quarterlyFeedback.quarterlyFeedbackText"
        [type]="'Primary'"
        (onClick)="onQuarterlyFeedbackClick()"
      ></emerald-button>
    </div>
    <div class="top-section">
      <app-contractor-vendor-head-count [vendorId]="vendorId"></app-contractor-vendor-head-count>
      <app-interviews-status [vendorId]="vendorId"></app-interviews-status>
    </div>
    <div class="quarterly-feedback-section">
      <h2 class="section-heading">{{ VendorProfile.quarterlyFeedback }}</h2>
      <app-quarterly-feedback [vendorId]="vendorId"></app-quarterly-feedback>
    </div>
    <div class="vendor-info-section">
      <h2 class="section-heading">{{ VendorProfile.vendorInfo }}</h2>
      <app-vendor-info [vendorId]="vendorId"></app-vendor-info>
    </div>
  </div>
</div>
